"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = Button;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
/** size 別の寸法。Figma の Button コンポーネントに準拠。 */
var SIZE_STYLE = {
    md: { height: 44, py: tokens_1.spacing.sm + tokens_1.spacing.xs, defaultWidth: 240 },
    sm: { height: 28, py: tokens_1.spacing.xs },
};
function Button(_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.tone, tone = _d === void 0 ? 'primary' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, href = _a.href, onClick = _a.onClick, startIcon = _a.startIcon, endIcon = _a.endIcon, sx = _a.sx;
    var p = (0, theme_1.useV2Palette)();
    var dimension = SIZE_STYLE[size];
    // variant ごとの面・枠線・文字色。disabled は variant によらず共通表現。
    var surface = function () {
        if (disabled) {
            return {
                backgroundColor: variant === 'text' ? 'transparent' : p.background.neutral.default,
                border: 'none',
                color: p.foreground.neutral.disabled,
                boxShadow: 'none',
            };
        }
        var isNeutral = tone === 'neutral';
        switch (variant) {
            case 'outline':
                return {
                    backgroundColor: isNeutral ? p.background.sub : p.background.surface,
                    border: "1px solid ".concat(isNeutral ? p.foreground.neutral.hint : p.foreground.primary.main),
                    color: isNeutral
                        ? p.foreground.neutral.primary
                        : p.foreground.primary.main,
                    boxShadow: 'none',
                };
            case 'text':
                return {
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: isNeutral
                        ? p.foreground.neutral.primary
                        : p.foreground.primary.main,
                    boxShadow: 'none',
                };
            case 'primary':
            default:
                return {
                    backgroundColor: p.background.primary.default,
                    border: 'none',
                    color: p.foreground.neutral.white,
                    boxShadow: p.shadow.brand,
                };
        }
    };
    var _g = surface(), backgroundColor = _g.backgroundColor, border = _g.border, color = _g.color, boxShadow = _g.boxShadow;
    return ((0, jsx_runtime_1.jsx)(material_1.ButtonBase, { component: href && !disabled ? 'a' : 'button', href: href && !disabled ? href : undefined, onClick: disabled ? undefined : onClick, disabled: disabled, disableRipple: variant === 'text', sx: __assign({ boxSizing: 'border-box', minHeight: dimension.height, width: fullWidth ? '100%' : dimension.defaultWidth, maxWidth: '100%', px: "".concat(tokens_1.spacing.md, "px"), py: "".concat(dimension.py, "px"), borderRadius: "".concat(tokens_1.radius.full, "px"), backgroundColor: backgroundColor, border: border, boxShadow: boxShadow, color: color, textDecoration: 'none', transition: 'opacity 0.15s ease', '&:hover': { opacity: disabled ? 1 : 0.92 }, 
            // MUI の Mui-disabled は色を上書きしないが、ポインタは無効にしておく
            '&.Mui-disabled': { pointerEvents: 'none' } }, sx), children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "center", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: { width: '100%', minWidth: 0 }, children: [startIcon, (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: __assign(__assign({}, tokens_1.textStyles.subtitle), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: 'inherit', textAlign: 'center' }), children: children }), endIcon] }) }));
}
